/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import {
  Title,
  Select,
  GoBack,
  TextArea,
  MyMessage,
  InputField,
  PhoneInput,
  SelectInput,
  MyActionButton,
} from "../../component/Component";
import {
  codeOk,
  errorMessage,
  pushCountry,
} from "../../../../middlewares/index";
import { useCountryContext } from "../../../../context/country/countryContext/CountryContext";
import { useTourPackageContext } from "../../../../context/tourPackage/TourPackageContext";
import { useAgentContext } from "../../../../context/agent/AgentContext";
import { ImageKitUpload } from "../../../../middlewares/libraries/imageKit/ImageKitLibrary";
import { FOLDERS, image_kit_folder } from "../../../doseeData/utils/Utils";
import { defaultImage } from "../../../../middlewares/libraries/imageKit/ImageKit";
import { countriesList } from "../../component/data";

const Add = () => {
  const { createOneAgent } = useAgentContext();
  const { countries, fetchCountries } = useCountryContext();
  const { tourPackages, fetchTourPackages } = useTourPackageContext();

  const [fetchedTour, setFetchedTour] = useState(null);

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const [title, setTitle] = useState(null);
  const [country, setCountry] = useState("Uganda");
  const [agent_package_id, setAgentPackageId] = useState(0);
  const [agent_payment_id, setAgentPaymentId] = useState(0);
  const [agent_email, setAgentEmail] = useState(null);
  const [agent_phone, setAgentPhone] = useState(null);
  const [agent_contact, setAgentContact] = useState(null);
  const [agent_transactions, setAgentTransactions] = useState(0);
  const [agent_rating, setAgentRating] = useState(0.0);
  const [description, setDescription] = useState(null);

  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");
  const [thumbnailLogo, setThumbnailLogo] = useState(null);
  const [thumbnailIdLogo, setThumbnailIdLogo] = useState(null);

  const agentRoutes = "/agent";

  useEffect(() => {
    if (!countries) fetchCountries();

    if (!tourPackages) {
      fetchTourPackages();
    } else {
      const this_tour = [];
      tourPackages.map((tour) =>
        this_tour.push({
          name: tour.title,
          id: tour.tour_package_id,
        })
      );
      setFetchedTour(this_tour);
    }
  }, [countries, tourPackages]);

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setAgentEmail(null);
    setAgentPhone(null);
    setAgentContact(null);
    setThumbnail(null);
    setThumbnailId(null);
    setThumbnailLogo(null);
    setThumbnailIdLogo(null);
    setAgentTransactions(0);
    setAgentRating(0.0);
    setTitle(null);
    setDescription(null);
  };

  const responses = (isError, message) => {
    setError(isError);
    setLoading(false);
    setErrorMessage(message);
  };

  const addOneAgentHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId || !thumbnailLogo || !thumbnailIdLogo) {
      setLoading(false);
      return responses(true, "Image or Logo Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      agent_package_id: agent_package_id,
      agent_payment_id: agent_payment_id,
      agent_biz_reg_no: title?.replace(/ /g, "-") || "reg-no-agent",
      logo: thumbnailLogo ? thumbnailLogo : defaultImage,
      logo_ref_id: thumbnailIdLogo,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      email_address: agent_email,
      phonenumber: agent_phone,
      contact_person_name: agent_contact,
      country: country ? country : "...",
      number_of_transaction: agent_transactions,
      rating: agent_rating,
      name: title,
      description: description,
    };

    const response = await createOneAgent(data);
    if (response) {
      if (response.data.status === codeOk) {
        cleanFields();
        return responses(true, response.data.message);
      } else {
        setLoading(false);
        return responses(true, response.data.message);
      }
    } else {
      setLoading(false);
      return responses(true, errorMessage);
    }
  };

  const hasProfileImage = !!thumbnailId;
  const hasLogo = !!thumbnailIdLogo;

  return (
    <div className="h-full overflow-y-auto bg-gray-50 p-4 rounded-b-xl">
      <div className="max-w-6xl mx-auto">
        <GoBack props={{ route: agentRoutes }} />

        {/* Header / Intro */}
        <div className="relative mt-3 mb-5">
          <div className="pointer-events-none absolute -inset-x-6 -top-6 h-24 rounded-3xl bg-gradient-to-r from-emerald-400/15 via-amber-400/15 to-fuchsia-400/15 blur-2xl -z-10" />
          <div className="relative rounded-2xl border border-gray-200 bg-white/90 shadow-sm backdrop-blur">
            <div className="flex flex-col gap-4 p-5 md:flex-row md:items-center md:justify-between">
              <div>
                <h1 className="text-base font-semibold tracking-tight text-gray-900">
                  Add Agent
                </h1>
                <p className="mt-0.5 text-xs text-gray-600">
                  Upload brand assets, contact details and package information.
                </p>
              </div>

              <div className="flex flex-wrap items-center gap-2">
                <StatusChip label="Profile Image" ok={hasProfileImage} />
                <StatusChip label="Logo" ok={hasLogo} />
              </div>
            </div>
          </div>
        </div>

        <form onSubmit={addOneAgentHandler} className="space-y-5">
          <MyMessage
            error={error}
            message={message}
            success={success}
            onExpired={() => {
              setError(false);
              setSuccess(false);
            }}
            onClick={() => {
              setError(false);
              setSuccess(false);
              setErrorMessage("");
            }}
          />

          {/* Media / Brand assets */}
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm p-4 md:p-5">
            <div className="mb-3 flex items-center justify-between">
              <Title props={{ title: "Brand Assets" }} />
              <span className="text-[11px] text-gray-500">
                JPEG/PNG — recommended square
              </span>
            </div>

            <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
              <div className="rounded-xl border border-dashed border-gray-200 p-3">
                <p className="mb-2 text-xs font-semibold text-gray-700">
                  Agent Profile
                </p>
                <ImageKitUpload
                  thumbnail={thumbnail}
                  thumbnailId={thumbnailId}
                  setThumbnail={setThumbnail}
                  setThumbnailId={setThumbnailId}
                  folder={image_kit_folder("dosee", FOLDERS.AGENTS)}
                />
              </div>

              <div className="rounded-xl border border-dashed border-gray-200 p-3">
                <p className="mb-2 text-xs font-semibold text-gray-700">
                  Agent Logo
                </p>
                <ImageKitUpload
                  thumbnail={thumbnailLogo}
                  thumbnailId={thumbnailIdLogo}
                  setThumbnail={setThumbnailLogo}
                  setThumbnailId={setThumbnailIdLogo}
                  folder={image_kit_folder("dosee", FOLDERS.AGENTS)}
                />
              </div>
            </div>
          </section>

          {/* Contact / Package */}
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm p-4 md:p-5">
            <div className="mb-3">
              <Title props={{ title: "Contact & Packages" }} />
            </div>

            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
              <SelectInput
                title="Country"
                defaultValue={country ? country : null}
                required={true}
                value={country ? country : null}
                options={countries ? countries?.map((x) => x?.name) : []}
                onChange={(e) => {
                  setCountry(e.target.value);

                  const pickedCountry = countriesList?.find(
                    (_c) =>
                      String(_c.name).toLowerCase() ===
                      String(e.target.value).toLowerCase()
                  );

                  pushCountry({
                    country: {
                      id: pickedCountry?.id,
                      name: pickedCountry?.name,
                      slug: pickedCountry?.name,
                      route: "/admin",
                    },
                  });
                }}
              />

              <PhoneInput
                phone={agent_phone}
                required={true}
                setPhone={setAgentPhone}
                country={country ? country : ""}
              />

              <Select
                props={{
                  id: "tour_package_id",
                  title: "Tour Package",
                  option:
                    fetchedTour !== null && tourPackages !== null
                      ? [...fetchedTour.map((_tour) => _tour.name)]
                      : [],
                  onChange: (e) => {
                    const index = e.target.selectedIndex;
                    setAgentPackageId(fetchedTour[index].id);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />

              <Select
                props={{
                  id: "agent_payment_id",
                  title: "Payment Method",
                  option: ["Visa", "Cash", "E-Wallet", "Mobile Money"],
                  onChange: (e) => {
                    const index = e.target.selectedIndex;
                    setAgentPaymentId(index);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </section>

          {/* Agent details */}
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm p-4 md:p-5">
            <div className="mb-3">
              <Title props={{ title: "Agent Details" }} />
            </div>

            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
              <InputField
                props={{
                  id: "title",
                  title: "Name",
                  type: "text",
                  value: title ? title : "",
                  onChange: (e) => {
                    setTitle(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />

              <InputField
                props={{
                  id: "agent_email",
                  title: "Agent Email",
                  type: "text",
                  value: agent_email ? agent_email : "",
                  onChange: (e) => {
                    setAgentEmail(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />

              <InputField
                props={{
                  id: "agent_contact",
                  title: "Agent Contact Person",
                  type: "text",
                  value: agent_contact ? agent_contact : "",
                  onChange: (e) => {
                    setAgentContact(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />

              <InputField
                props={{
                  id: "agent_transaction",
                  title: "Agent Transactions",
                  type: "number",
                  value: agent_transactions ? agent_transactions : "",
                  onChange: (e) => {
                    setAgentTransactions(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />

              <InputField
                props={{
                  id: "agent_rating",
                  title: "Agent Rating",
                  type: "number",
                  value: agent_rating ? agent_rating : "",
                  onChange: (e) => {
                    setAgentRating(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>

            <div className="mt-4">
              <TextArea
                props={{
                  id: "description",
                  title: "Description",
                  type: "text",
                  value: description ? description : "",
                  onChange: (e) => {
                    setDescription(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </section>

          {/* Action */}
          <div className="flex items-center justify-end w-full">
            <div className="flex justify-center items-center rounded-xl bg-white shadow-sm ring-1 ring-gray-200 p-2 w-full">
              <MyActionButton
                className="min-w-[200px]"
                loading={loading}
                title="Add Agent"
                onClick={() => {
                  setError(false);
                  setSuccess(false);
                  setErrorMessage(null);
                }}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Add;

const StatusChip = ({ label, ok }) => {
  return (
    <span
      className={[
        "inline-flex items-center gap-2 rounded-full px-2.5 py-1 text-[11px] font-medium ring-1",
        ok
          ? "bg-emerald-50 text-emerald-700 ring-emerald-200"
          : "bg-gray-50 text-gray-600 ring-gray-200",
      ].join(" ")}
    >
      <span
        className={[
          "h-1.5 w-1.5 rounded-full",
          ok ? "bg-emerald-500" : "bg-gray-300",
        ].join(" ")}
      />
      {label}
    </span>
  );
};
